import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';

/** Plain-text system events. Stored line breaks remain part of the message;
 * content is never parsed as HTML or split by labels inside a user comment. */
export default function SystemMessage({ content, time, dateTime, ...events }) {
  const lines = String(content ?? '').replace(/\r\n?/g, '\n').split('\n');
  const titleIndex = lines.findIndex(line => line.trim());
  const hasDetails = lines.some((line, index) => index > titleIndex && line.trim());

  return (
    <Box
      component="article"
      aria-label="Системное сообщение"
      {...events}
      sx={(theme) => ({
        alignSelf: 'flex-start',
        mr: 'auto',
        minWidth: 0,
        width: 'fit-content',
        maxWidth: { xs: '100%', sm: 'min(720px, 90%)' },
        boxSizing: 'border-box',
        px: { xs: 1.5, sm: 1.75 },
        py: 1.25,
        borderRadius: '12px',
        borderTopLeftRadius: '4px',
        border: '1px solid',
        borderColor: theme.palette.mode === 'dark'
          ? 'rgba(183,203,223,.16)' : 'rgba(111,133,159,.17)',
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(157,185,213,.10)' : 'rgba(232,240,246,.88)',
        color: 'text.primary',
        textAlign: 'left',
      })}
    >
      <Box>
        {lines.map((line, index) => line.trim() ? (
          <Typography
            component="p"
            level="body-sm"
            key={index}
            sx={{
              m: 0,
              color: 'inherit',
              fontSize: 14,
              lineHeight: 1.55,
              fontWeight: hasDetails && index === titleIndex ? 600 : 400,
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              wordBreak: 'normal',
            }}
          >
            {line}
          </Typography>
        ) : <Box key={index} aria-hidden="true" sx={{ height: 8 }} />)}
      </Box>
      {time && (
        <Typography
          component="time"
          dateTime={dateTime || undefined}
          level="body-xs"
          sx={{ display: 'block', textAlign: 'right', color: 'text.tertiary', fontSize: 11, lineHeight: '16px', mt: 0.5 }}
        >
          {time}
        </Typography>
      )}
    </Box>
  );
}
